import { fromCustomBase64, getUrlSubDirByIndex } from './common';

export function getInitialCatalogueSearch(model) {
	const decoded = fromCustomBase64(getUrlSubDirByIndex(1));
	const search = decoded.success && decoded.obj && typeof decoded.obj === 'object' && !Array.isArray(decoded.obj)
		? decoded.obj : model;
	return { searchTerm: '', and: true, bundleCategoryIDs: [], socialMediaTypes: [], bundleTypes: [],
		free: false, discounted: false, pageSize: 9, pageIndex: 0, ...search,
		bundleCategoryIDs: search?.bundleCategoryIDs ?? [], socialMediaTypes: search?.socialMediaTypes ?? [] };
}

export function startCatalogueSearch(model, request = fetch) {
	const search = getInitialCatalogueSearch(model);
	const promise = request('/api/guest/GetBundlesSearchStartup', {
		method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(search)
	}).then(async response => {
		if (!response.ok) throw new Error('Could not load bundles.');
		return { data: await response.json() };
	}).catch(error => ({ error })); // Vue consumes failures; never leave a detached rejection.
	return { search, promise };
}
